import '../../_rollupPluginBabelHelpers-a38db067.js';
import '../utils.js';
import '../core/core-utils.js';
import '../core/parser.js';
import '../core/style-function.js';
import { system } from '../core/system.js';

const config = {
  position: {
    property: 'position'
  },
  zIndex: {
    property: 'zIndex'
  },
  top: {
    property: 'top'
  },
  right: {
    property: 'right'
  },
  bottom: {
    property: 'bottom'
  },
  left: {
    property: 'left'
  },
  inset: {
    property: 'inset'
  },
  insetBlock: {
    property: 'insetBlock'
  },
  insetBlockEnd: {
    property: 'insetBlockEnd'
  },
  insetBlockStart: {
    property: 'insetBlockStart'
  },
  insetInline: {
    property: 'insetInline'
  },
  insetInlineEnd: {
    property: 'insetInlineEnd'
  },
  insetInlineStart: {
    property: 'insetInlineStart'
  }
};
const position = system(config);

export { position };
